import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '../ResponsiveImage';
import { StyledSplitPanelBody, IconContainer, Header, Body } from './styles.js';

export const VerticalPanelBody = ({ icon, heading, body }) => {
  return (
    <StyledSplitPanelBody>
      {icon && (
        <IconContainer>
          <ResponsiveImage
            alt={icon.alt}
            src={icon.src}
            width={icon.width}
            height={icon.height}
          />
        </IconContainer>
      )}
      {heading && <Header>{heading}</Header>}
      <Body>{body}</Body>
    </StyledSplitPanelBody>
  );
};

VerticalPanelBody.displayName = 'VerticalPanelBody';

VerticalPanelBody.propTypes = {
  icon: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
  }),
  heading: PropTypes.string,
  body: PropTypes.node,
};
